<template>
  <div class="transport-box">
    <div class="transport-heading" @click="toggle">
      <div class="heading-content transport-heading-content">
        <i v-if="transportMode.icon === 'walking'" class="material-icons">directions_walk</i>
        <i v-else :class="[`icon-${transportMode.icon}`]" />
        <span class="site-name">{{ $t(`transportMode.${transportMode.key}`) }}</span>
      </div>
      <span :class="['icon-container', { reversed: opened }]">
        <i class="icon-arrow_down" />
      </span>
    </div>
    <div v-if="opened" class="section-container">
      <div
        v-for="(section, idx) in transport.sections"
        :key="section.name"
        :class="[
          'section-entry',
          {
            active: isActive(idx),
          },
        ]"
        @click="() => selectSection(idx)"
      >
        {{ $t(`sections.${section.name}`) }} <i v-if="section.comment" class="icon-bubble"></i>
      </div>
    </div>
  </div>
</template>

<script>
import TransportMode from '@/pure/TransportMode';
import { eventBus } from '@/eventBus';

export default {
  props: ['transport', 'idxs', 'activeSection'],

  data() {
    return {
      opened: false,
    };
  },

  computed: {
    transportMode() {
      return TransportMode.find(mode => mode.index === this.transport.type);
    },
  },

  methods: {
    isActive(idx) {
      const { activeSection } = this;
      return activeSection.siteIdx === this.idxs.siteIdx && activeSection.transportIdx === this.idxs.transportIdx && activeSection.sectionIdx === idx;
    },

    toggle() {
      this.opened = !this.opened;
    },

    selectSection(idx) {
      if (this.isActive(idx)) {
        eventBus.emit('selectSection', null);
      } else {
        eventBus.emit('selectSection', {
          siteIdx: this.idxs.siteIdx,
          transportIdx: this.idxs.transportIdx,
          sectionIdx: idx,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.icon-container {
  display: flex;
  &.reversed {
    transform: rotate(180deg);
  }
}
.heading-content {
  flex: 1;
  box-sizing: border-box;
  padding-left: 29px;
  cursor: pointer;
  display: flex;
  align-items: center;
  i {
    font-size: 1.25em;
  }
  .site-name {
    font-size: 16px;
    font-weight: 600;
    padding-left: 0.125em;
  }
}
.transport-heading {
  height: 55px;
  display: flex;
  border-bottom: 1px solid #e3e3e3;
  align-items: center;
  cursor: pointer;
}
.section-container {
  padding-left: 64px;
  border-bottom: 1px solid #e3e3e3;
  padding-top: 15px;
  padding-bottom: 15px;

  .section-entry {
    display: flex;
    align-items: center;
    padding: 5px 0;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &.active,
    &:hover {
      color: #318eaf;
      font-weight: 600;
    }

    .icon-bubble {
      font-size: 24px;
      margin: -10px 0;
    }
  }
}
</style>
